module.exports = __webpack_public_path__ + "static/media/chart.2625d4fb.svg";